export default __webpack_public_path__ + "static/media/call_to_action.845dfc44.svg";